<script lang="ts">
  // Renders an image once it exists at `src`; until then (or if it fails to
  // load) it shows an on-brand placeholder noting the expected file path, so
  // generated art can be dropped into /public and appears automatically.
  let {
    src,
    alt,
    ratio = "4 / 3",
    label = "",
    rounded = true,
  }: {
    src: string;
    alt: string;
    ratio?: string;
    label?: string;
    rounded?: boolean;
  } = $props();

  let failed = $state(false);
</script>

<figure class="img" class:rounded style="aspect-ratio: {ratio}">
  {#if src && !failed}
    <img {src} {alt} loading="lazy" decoding="async" onerror={() => (failed = true)} />
  {:else}
    <div class="ph" role="img" aria-label={alt}>
      <svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true">
        <path d="M3 5h18v14H3z" fill="none" stroke="currentColor" stroke-width="1.4" />
        <circle cx="8.5" cy="10" r="1.8" fill="currentColor" />
        <path d="M3 17l5-4 4 3 4-4 5 5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      {#if label}<span class="lab">{label}</span>{/if}
      <code>{src}</code>
    </div>
  {/if}
</figure>

<style>
  .img {
    position: relative;
    margin: 0;
    width: 100%;
    overflow: hidden;
    background: var(--paper-deep);
  }
  .img.rounded {
    border-radius: var(--radius);
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .ph {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 1rem;
    text-align: center;
    color: var(--green);
    border: 1.5px dashed var(--line-strong);
    border-radius: inherit;
    background:
      repeating-linear-gradient(
        45deg,
        transparent,
        transparent 11px,
        rgba(95, 179, 100, 0.05) 11px,
        rgba(95, 179, 100, 0.05) 22px
      ),
      var(--paper-card);
  }
  .lab {
    font-family: var(--font-mincho);
    font-size: 0.95rem;
    color: var(--ink-soft);
    line-height: 1.5;
  }
  code {
    font-family: var(--font-mono);
    font-size: 0.66rem;
    letter-spacing: 0.02em;
    color: var(--muted);
    background: var(--paper);
    border: 1px solid var(--line);
    padding: 0.2em 0.55em;
    border-radius: 6px;
    max-width: 92%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
